<template>
  <ul v-if="items" class="flex flex-col gap-y-8 sm:gap-y-12">
    <li
      v-for="(item, i) in items"
      :key="item.id"
      :class="
        i !== items.length - 1
          ? 'border-b border-gray-lighten1 pb-8 sm:pb-12'
          : 'pb-4 sm:pb-6'
      "
    >
      <div class="mb-6 flex w-full">
        <div
          class="mr-4 h-[70px] w-[70px] flex-shrink-0 sm:mr-6 sm:h-[97px] sm:w-[97px]"
        >
          <CdnImg
            v-if="item.image"
            :src="handleImageSrc(item.image)"
            :alt="handleImageAlt(item.image)"
            loading="lazy"
            class="h-full w-full object-contain"
            :width="97"
            :height="97"
          />
        </div>

        <div class="flex w-full max-w-[430px] flex-col text-slate sm:py-3">
          <h5 class="title mb-1 text-md leading-[1.8rem]" v-html="item.name" />

          <p class="text-sm leading-[1.225rem]" v-html="item.description" />
        </div>
      </div>

      <div
        v-if="item.files && item.files.length"
        class="flex flex-col gap-x-4 gap-y-2 sm:flex-row"
      >
        <div
          v-for="file in item.files"
          :key="file.id"
          class="rounded-lg bg-gray-lighten3 p-4 sm:w-[211px]"
        >
          <UiLink
            :to="filterLink(file.file)"
            class="flex w-full leading-none text-blue"
          >
            <span class="mr-2 inline-flex h-8 w-8">
              <UiIcon icon="download" container-size></UiIcon>
            </span>

            <span class="flex flex-col">
              <span
                class="title mb-1 text-sm uppercase leading-none tracking-[0.12em]"
                v-html="file.name"
              />

              <span
                class="text-[0.75rem] leading-4 text-slate"
                v-html="file.version"
              />
            </span>
          </UiLink>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  items?: any[];
}

withDefaults(defineProps<Props>(), {
  items: () => [],
});

const { fullPath } = useRuntimeConfig().public.frontkit;

const filterLink = (path: string) => {
  const isExternalLink = /^https?:/.test(path);

  if (isExternalLink) {
    return path;
  }

  return `${fullPath}${path}`;
};
</script>
